import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import {
  NgbModal,
  NgbModalModule,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CustomerSupportService } from 'src/app/_services/customer-support.service';
import { Admin } from 'src/app/_types/auth.types';
import { CustomerSupportAssignableEntities } from 'src/app/_types/customer-support.types';

@Component({
  selector: 'app-assign-customer-support-modal',
  templateUrl: './assign-customer-support-modal.component.html',
  styleUrls: ['./assign-customer-support-modal.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgbModalModule,
    MatSelectModule,
    MatFormFieldModule,
  ],
})
export class AssignCustomerSupportModalComponent implements OnInit {
  entityId!: string;

  entityType!: CustomerSupportAssignableEntities;

  @ViewChild('content', { static: true }) content!: TemplateRef<HTMLElement>;

  modalRef!: NgbModalRef;

  customerSupportList: Admin[] = [];

  @Output()
  done = new EventEmitter();

  customerSupportId!: string;

  submitted = false;

  constructor(
    private readonly modalService: NgbModal,
    private readonly toastrService: ToastrService,
    private readonly customerSupportService: CustomerSupportService
  ) {}

  openModal(entityId: string, entityType: CustomerSupportAssignableEntities) {
    this.entityId = entityId;
    this.entityType = entityType;

    this.modalRef = this.modalService.open(this.content, {
      scrollable: true,
      size: 'md',
      centered: true,
    });
  }

  ngOnInit(): void {
    this.customerSupportService.getActiveCustomerSupportList().subscribe({
      next: (res) => {
        this.customerSupportList = res.data.customerSupportAgentsList.sort(
          (x, y) => x.firstName.localeCompare(y.firstName)
        );
      },
    });
  }

  assignToCustomerSupport() {
    if (!this.canSubmit() || this.submitted) return;
    this.submitted = true;
    this.customerSupportService
      .assignCustomerSupportToElement(
        this.customerSupportId,
        this.entityId,
        this.entityType
      )
      .subscribe({
        next: () => {
          this.toastrService.success(
            $localize`Chargé de clientèle attribué avec succès`
          );
          this.done.emit();
          this.modalRef.dismiss();
          this.submitted = false;
        },
        error: () => {
          this.toastrService.error(
            $localize`Une erreur est survenue. Veuillez réessayer`
          );
          this.submitted = false;
        },
      });
  }

  canSubmit() {
    return this.entityId && this.entityType && this.customerSupportId;
  }
}
